export function installViewportUnits({ root = document.documentElement } = {}) {
    if (typeof window === 'undefined' || !root) return () => { };

    let rafId = 0;

    function updateNow() {
        rafId = 0;

        const vv = window.visualViewport;

        // visualViewport is the most accurate for mobile browser UI chrome (address bars).
        const height = (vv && typeof vv.height === 'number' ? vv.height : window.innerHeight) || 0;
        const width = (vv && typeof vv.width === 'number' ? vv.width : window.innerWidth) || 0;

        // CSS expects a length; we store 1% units as px.
        root.style.setProperty('--app-vh', `${height * 0.01}px`);
        root.style.setProperty('--app-vw', `${width * 0.01}px`);
    }

    function schedule() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(updateNow);
    }

    updateNow();

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    document.addEventListener('visibilitychange', schedule);

    if (window.visualViewport) {
        // iOS Safari can change viewport height on scroll as the browser chrome collapses/expands.
        window.visualViewport.addEventListener('resize', schedule, { passive: true });
        window.visualViewport.addEventListener('scroll', schedule, { passive: true });
    }

    return () => {
        window.removeEventListener('resize', schedule);
        window.removeEventListener('orientationchange', schedule);
        document.removeEventListener('visibilitychange', schedule);

        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', schedule);
            window.visualViewport.removeEventListener('scroll', schedule);
        }

        if (rafId) {
            window.cancelAnimationFrame(rafId);
            rafId = 0;
        }
    };
}
